// extracted by mini-css-extract-plugin
export default {"wired":"WvmrgK"};